import React from 'react';
import './style.scss';

const Contact = () => {
  return (
    <div id='contact' className='contact-container'>
      <h2>Contact Me</h2>
      <p>
        If you have any questions or would like to get in touch, feel free to
        reach out!
      </p>
      <p>
        Email: <a href='mailto:psangle41@gmail.com'>psangle41@gmail.com</a>
      </p>
    </div>
  );
};

export default Contact;
